import UserPendingSvg from "@icons/user-pending.svg?react";
import { Trans } from "@lingui/react/macro";

import { PendingUserBanner } from "@/common/components/pending-user-banner/pending-user-banner";
import { useErpCompany } from "@/common/hooks/use-erp-company";

const RequireErpCompany = ({ children }: React.PropsWithChildren) => {
  const erpCompany = useErpCompany();

  if (erpCompany) {
    return children;
  }

  return (
    <PendingUserBanner.Screen>
      <Message />
    </PendingUserBanner.Screen>
  );
};

const Message = () => (
  <>
    <UserPendingSvg className="shrink-0" />
    <p className="text-[#c28519] py-3">
      <Trans>
        <strong>Vaše firma čeká na propojení s obchodním systémem.</strong>{" "}
        Propojení proběhne po schválení firmy, zkuste to prosím později. Pro
        více informací nás můžete kontaktovat na e-mailové adrese:{" "}
        <a
          className="text-[#C28519] underline"
          href="mailto:support@cleverfarm.ag"
        >
          support@cleverfarm.ag
        </a>
        .
      </Trans>
    </p>
  </>
);

export { RequireErpCompany };
